<template>
  <div>
    <Breadcrumb :items="breadcrumbItems" />
    
    <AcaoForm
      @save="handleSave"
      @cancel="handleCancel"
    />
  </div>
</template>

<script>
import Breadcrumb from "../../../components/breadcrumbs/Breadcrumb.vue";
import AcaoForm from "../../../components/forms/AcaoForm.vue";
import { AcaoService } from "../../../services/AcaoService";

export default {
  name: "CriarAcao",
  components: {
    Breadcrumb,
    AcaoForm
  },
  data() {
    return {
      breadcrumbItems: [
        {
          text: "Início",
          disabled: false,
          href: "/"
        },
        {
          text: "Ações",
          disabled: false,
          href: "/acoes"
        },
        {
          text: "Criar Ação",
          disabled: true,
          href: "/acoes/criar"
        }
      ]
    };
  },
  methods: {
    async handleSave(formData) {
      try {
        // Criar FormData seguindo o padrão existente
        const postData = new FormData();
        
        postData.append("exercicio", formData.exercicio);
        postData.append("codigo_acao", formData.codigoAcao);
        postData.append("descricao_acao", formData.descricaoAcao);
        postData.append("codigo_sub_acao", formData.codigoSubAcao);
        postData.append("sub_acao_descricao", formData.codigoSubAcao); // Usando o mesmo valor
        postData.append("funcao", formData.codigoFuncao);
        postData.append("descricao_funcao", formData.descricaoFuncao);
        postData.append("codigo_sub_funcao", formData.codigoSubFuncao);
        postData.append("descricao_sub_funcao", formData.subAcaoFuncao);
        postData.append("ativo", formData.ativo ? 1 : 0);
        
        const response = await AcaoService.store(postData);
        
        if (response) {
          // Redirecionar para a lista de ações após salvar
          this.$router.push('/gerenciar-acoes');
        } else {
          throw new Error('Erro ao criar ação');
        }
      } catch (error) {
        console.error('Erro ao criar ação:', error);
        // O componente AcaoForm já trata a exibição de mensagens de erro
        throw error;
      }
    },
    handleCancel() {
      // Retornar para a tela principal do menu
      this.$router.push('/gerenciar-acoes');
    }
  }
};
</script>

<style scoped>
/* Estilos específicos da página, se necessário */
</style>